// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_6CGsVOXb0Xl4iVlkrazpk","icon":"_11rc2vx-Ky5Wq8LozQ8aYF","active":"_1UG0o58FvhHY1ruaF7JIXW"};